module.exports = __webpack_public_path__ + "media/images/icons/material/link-box-22e31c690ad7617b2bfc5bdfee48898d.svg";